import React from 'react';

/**
 * BusinessNameInput Component
 * Renders a text input for the business name with validation feedback.
 * Props:
 *  - state: form state object
 *  - handleChange: input change handler
 */
const BusinessNameInput = ({ state, handleChange }) => {
  return (
    <div className="form-floating mb-4 position-relative">
      <input
        type="text"
        className={`form-control ${state.errors.businessName ? 'is-invalid' : state.businessName ? 'is-valid' : ''}`}
        id="businessName"
        name="businessName"
        value={state.businessName}
        onChange={handleChange}
        required
        placeholder=" "
        autoComplete="off"
      />
      <label htmlFor="businessName">Business Name</label>
      
      {/* Show error tooltip if validation fails */}
      {state.errors.businessName && <div className="invalid-tooltip">{state.errors.businessName}</div>}

      {/* Show success tooltip if field is valid */}
      {state.businessName && !state.errors.businessName && <div className="valid-tooltip">Business Name is valid</div>}
    </div>
  );
};

export default BusinessNameInput; 